import {
  SUPERVISOR_ADMINISTRATION_SECTION_IDS,
  SUPERVISOR_ADMINISTRATION_TEXT,
} from './constants.ts';
import type {
  TSupervisorAdministrationPageConfig,
  TSupervisorAdministrationPageKey,
  TSupervisorAdministrationSection,
} from './types.ts';

export const supervisorAdministrationPageKeys = [
  'usapok',
  'umvn',
  'uo',
  'udbtf',
] as const satisfies readonly TSupervisorAdministrationPageKey[];

export const guaranteesAdministrationSections: TSupervisorAdministrationSection[] = [
  {
    id: SUPERVISOR_ADMINISTRATION_SECTION_IDS.responsible,
    title: SUPERVISOR_ADMINISTRATION_TEXT.guaranteesResponsibleTitle,
    users: [],
  },
  {
    id: SUPERVISOR_ADMINISTRATION_SECTION_IDS.controller,
    title: SUPERVISOR_ADMINISTRATION_TEXT.guaranteesControllerTitle,
    users: [],
  },
];

const buildResponsibleSection = (id: string): TSupervisorAdministrationSection[] => [
  {
    id,
    title: SUPERVISOR_ADMINISTRATION_TEXT.guaranteesResponsibleTitle,
    users: [],
  },
];

export const supervisorAdministrationPageConfigs: Record<
  TSupervisorAdministrationPageKey,
  TSupervisorAdministrationPageConfig
> = {
  usapok: {
    routePath: 'usapok',
    path: '/administrator/usapok',
    apiPathSegment: 'usapok',
    navigationTitle: SUPERVISOR_ADMINISTRATION_TEXT.usapokPageTitleSuffix,
    titleSuffix: SUPERVISOR_ADMINISTRATION_TEXT.usapokPageTitleSuffix,
    subtitle: SUPERVISOR_ADMINISTRATION_TEXT.administrationStubSubtitle,
    sections: buildResponsibleSection(SUPERVISOR_ADMINISTRATION_SECTION_IDS.usapokResponsible),
  },
  umvn: {
    routePath: 'umvn',
    path: '/administrator/umvn',
    apiPathSegment: 'umvn',
    navigationTitle: SUPERVISOR_ADMINISTRATION_TEXT.umvnPageTitleSuffix,
    titleSuffix: SUPERVISOR_ADMINISTRATION_TEXT.umvnPageTitleSuffix,
    subtitle: SUPERVISOR_ADMINISTRATION_TEXT.administrationStubSubtitle,
    sections: buildResponsibleSection(SUPERVISOR_ADMINISTRATION_SECTION_IDS.umvnResponsible),
  },
  uo: {
    routePath: 'uo',
    path: '/administrator/uo',
    apiPathSegment: 'uo',
    navigationTitle: SUPERVISOR_ADMINISTRATION_TEXT.uoPageTitleSuffix,
    titleSuffix: SUPERVISOR_ADMINISTRATION_TEXT.uoPageTitleSuffix,
    subtitle: SUPERVISOR_ADMINISTRATION_TEXT.administrationStubSubtitle,
    sections: buildResponsibleSection(SUPERVISOR_ADMINISTRATION_SECTION_IDS.uoResponsible),
  },
  udbtf: {
    routePath: 'udbtf',
    path: '/administrator/udbtf',
    apiPathSegment: 'udbtf',
    navigationTitle: SUPERVISOR_ADMINISTRATION_TEXT.udbtfPageTitleSuffix,
    titleSuffix: SUPERVISOR_ADMINISTRATION_TEXT.udbtfPageTitleSuffix,
    subtitle: SUPERVISOR_ADMINISTRATION_TEXT.administrationStubSubtitle,
    sections: buildResponsibleSection(SUPERVISOR_ADMINISTRATION_SECTION_IDS.udbtfResponsible),
  },
};

export const getSupervisorAdministrationPageConfig = (
  pageKey: TSupervisorAdministrationPageKey
): TSupervisorAdministrationPageConfig => supervisorAdministrationPageConfigs[pageKey];
